import EventBus from '@/event-bus';
import Products from '@/products';
import Shop from '@/shop';
import createStore from '@/storage';
import renderRecaptchaWidgetOnVisible from '@/google-recaptcha/renderRecaptchaWidgetOnVisible';
import renderYandexCaptchaWidgetOnVisible from '@/yandex-captcha/renderCaptchaWidgetOnVisible';
import getCaptchaMessageData from '@/helpers/getCaptchaMessageData';
import resetCaptcha from '@/helpers/resetCaptcha';
import _Singleton from '@/tools/singleton';
import URL from '@/tools/url';
import CartDOM from '@/ui/ui_cart';
import jquery from 'jquery';
import _forEach from 'lodash/forEach';
import _isEqual from 'lodash/isEqual';
import defaultSettings from '@/ui/ui_quick-checkout/default-settings.json';
import initPhoneFieldMask from '@/ui/ui_quick-checkout/inputmask.js';

import selectors from '@/ui/ui_quick-checkout/quick-checkout-selectors.json';

import { CAPTCHA_TYPE_GOOGLE, CAPTCHA_TYPE_YANDEX } from '@/constants';

const currency = Shop.config.config.currency_code;
const Store = createStore({ name: `quick-checkout-${currency}` });

/**
 * UI часть для "Заказа в один клик" и формы заявки (service)
 * @memberof Cart
 * @class
 * @alias Cart.quickCheckout
 *
 * @private
 */
const QuickCheckoutUI = function() {
  const self = this;
  self.selectors = selectors;
  self.defaultSettings = defaultSettings;

  document.addEventListener('DOMContentLoaded', function() {
    self._init();
  });

  return;
};

/**
 * Инициализация
 * @method
 * @private
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype._init = function() {
  const self = this;

  Store.setItem('quick-checkout', null);

  self.locale = Shop.config.config.locale;
  self.captchaType = Shop.config.config.captcha_type;
  self.$modals = jquery(self.selectors.modal.value);
  self.$message = jquery(self.msgModal);

  if (self.$modals.length && !self.$message.length) {
    // eslint-disable-next-line max-len
    self.$message = jquery('<div id="insales-quick-checkout-msg" class="m-modal m-modal--msg">\n<div class="m-modal-wrapper">\n<button class="button m-button m-modal-close" data-modal="close"></button>\n<div class="m-modal-msg center"></div>\n</div>\n</div>');
    self.$message.appendTo(jquery('body'));
  }

  _forEach(self.$modals, function(modal) {
    const modalHandle = modal.dataset[self.selectors.handle.data] || 'default';

    self[modalHandle] = {};
    self[modalHandle].$modal = jquery(modal);
    self[modalHandle].$send = self[modalHandle].$modal.find(self.selectors.sendButton.value);
    self[modalHandle].$errors = self[modalHandle].$modal.find(self.selectors.errors.value);
    self[modalHandle].$form = self[modalHandle].$modal.find(self.selectors.form.value);
    self[modalHandle].$close = jquery(self.selectors.closeButton.value);

    const captchaEnabledInput = self[modalHandle].$modal.find(
      '[name="quick_checkout_captcha_enabled"]'
    );
    self[modalHandle].captchaEnabled =
      captchaEnabledInput.length && captchaEnabledInput.val() === 'true';

    // Флаг который определяет будем ли мы делать отдельный запрос к корзине со всеми товарами, или будем слать только текущий товар в форме
    self[modalHandle].useCommonCart = modal.hasAttribute(self.selectors.useCommonCart.value);

    // Добавляем блок капчи в шаблонах 4 поколения
    self._createCaptchaBlock(modalHandle);
    self._createRecentlyViewedProductInput(modalHandle);
    self._appendLangLocale(modalHandle);
    self._bindCloseModal(modalHandle);
    self._bindSend(modalHandle);
    self._bindMessage(modalHandle);
  });

  self.$overlay = jquery('<div class="m-overlay" />');
  self._bindOpenModal();
};

/**
 * Создание блока капчи для модального окна
 * @method
 * @private
 * @param {string} modalHandle - handle модального окна (service/default)
 * @returns {void}
 */
QuickCheckoutUI.prototype._createCaptchaBlock = function(modalHandle) {
  const self = this;

  if ((Shop.config.config.theme_generation < 4 || !self[modalHandle].captchaEnabled) && self.captchaType === CAPTCHA_TYPE_GOOGLE) {
    return;
  }

  if (!self[modalHandle].captchaEnabled) { return; }

  let captchaBlock = self[modalHandle].$form.find('.co-input.co-input--text.co-input--captcha').get(0);

  if (!captchaBlock) {
    captchaBlock = document.createElement('div');
  }

  if (self.captchaType === CAPTCHA_TYPE_YANDEX && captchaBlock.children.length) {
    captchaBlock.innerHTML = '';
  }

  captchaBlock.classList = 'co-input co-input--text co-input--captcha';

  self[modalHandle].captchaBlockInner = document.createElement('div');

  if (self.captchaType === CAPTCHA_TYPE_YANDEX) {
    self[modalHandle].captchaBlockInner.id = self.selectors.yandexCaptcha.name;
    self[modalHandle].captchaBlockInner.dataset.yandexCaptchaType = 'invisible';
  }

  if (self.captchaType === CAPTCHA_TYPE_GOOGLE) {
    self[modalHandle].captchaBlockInner.id = self.selectors.recaptcha.name;
    self[modalHandle].captchaBlockInner.dataset.recaptchaType = 'invisible';
  }

  captchaBlock.append(self[modalHandle].captchaBlockInner);
  self[modalHandle].$form.find('.m-modal-footer').before(captchaBlock);
};

/**
 * Открытие модалки
 * @method
 *
 * @param {Object} $modal - jQuery-нода модалки
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype.openModal = function($modal) {
  const self = this;
  $modal.css({
    position: 'fixed',
    display: 'block'
  });
  jquery('body').append(self.$overlay);
};

/**
 * Передача просмотренных товаров
 * @method
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype._createRecentlyViewedProductInput = function(modalHandle) {
  const self = this;

  Products.getRecentlyViewed().done(function(order) {
    const inputReviews = jquery(
      '<input type="hidden" name="order[viewed_product_ids]" />'
    );
    inputReviews.val(JSON.stringify(order));
    jquery(self[modalHandle].$form).append(inputReviews);
  });
};

/**
 * Передача локали
 * @method
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype._appendLangLocale = function(modalHandle) {
  const self = this;
  const lang = URL.getKeyValue('lang') || '';
  const inputLang = jquery('<input type="hidden" name="lang" />');

  inputLang.val(lang);
  jquery(self[modalHandle].$form).append(inputLang);
};

/**
 * Прибиваем сообщения успешной/ошибки отправки
 * @method
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype._bindMessage = function(modalHandle) {
  const self = this;
  const modal = self[modalHandle];

  EventBus.subscribe('errors:insales:quick_checkout', function(task) {
    self.showErrors(task, modalHandle);
  });

  EventBus.subscribe('success:insales:quick_checkout', function(eventData) {
    const task = eventData.task ? eventData.task : eventData;
    self.showMessage(task, modalHandle);
    modal.$form[0].reset();
  });

  EventBus.subscribe('always:insales:quick_checkout', function() {
    modal.sending = false;
  });
};

/**
 * При отправке формы пришли ошибки
 * @method
 * @private
 *
 * @param {Object} task - Задача
 * @param {string} modalHandle - handle модального окна (service/default)
 * @returns {void}
 */
QuickCheckoutUI.prototype.showErrors = function(task, modalHandle) {
  const self = this;
  const modal = self[modalHandle];

  // Проверяем, если в корзине есть ошибки связанные с опциями, и в чекауте ошибка связана с тем, что не выбран ни один товар, то выводим ошибку
  let hasAccessoriesErrors = false;

  if (
    window.InsalesCommonCart.order.errors.length &&
    task.errors.items &&
    task.errors.items.length
  ) {
    window.InsalesCommonCart.order.errors.forEach(function(errorsArray) {
      if (!errorsArray || !errorsArray.length) { return; }

      errorsArray.forEach(function(errorItem) {
        if (!errorItem) { return; }
        if (errorItem.accessory_id) { hasAccessoriesErrors = true; }
      });

      if (hasAccessoriesErrors) {
        modal.$errors.append(
          jquery(`<div class="m-modal-error">${self._getMessageByLocale('errorAccessories')}</div>`)
        );
      }
    });
  }

  _forEach(task.errors, function(errorMessage, key) {
    if (hasAccessoriesErrors && key === 'items') { return; }
    modal.$errors.append(
      jquery(`<div class="m-modal-error">${errorMessage}</div>`)
    );
  });

  // Сбрасываем капчу после показа ошибок
  resetCaptcha({
    captchaType: self.captchaType,
    yandexCaptchaBlockSelector: self.selectors.yandexCaptcha.value,
    googleRecaptchaBlockSelector: self.selectors.recaptcha.value,
  });
};

/**
 * Закрытие модалки
 * @method
 *
 * @param {Object} $modal - jQuery-нода модалки
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype.closeModal = function($modal, modalHandle) {
  const self = this;
  $modal.removeAttr('style');
  self.$overlay.remove();
  self.targetFormState(false, modalHandle);
};

/**
 * Открыть модалку без кнопки
 * @method
 *
 * @param {HTMLElement|jQuery} target - jQuery-нода формы товара
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype.openQuickCheckoutModal = function(target) {
  const self = this;
  if (!jquery(target).is('form')) {
    console.warn('QuickCheckoutUI:openQuickCheckoutModal: В метод не передали форму');

    return;
  }

  self._targetForm = jquery(target);
  self.openModal(self.$modal);
  self.$form.find('input:visible:first').focus();
};

/**
 * Обработчик открытия модалки
 * @method
 * @private
 *
 * @fires add_disabled:insales:quick_checkout
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype._bindOpenModal = function() {
  const self = this;

  jquery(document).on('click', '[data-quick-checkout]', function(event) {
    event.preventDefault();
    event.stopPropagation();
    const $button = jquery(this);
    const modalHandle =
      $button.data(self.selectors.modalHandle.data) || 'default';
    const modal = self[modalHandle];
    const $modalNode = modal.$modal;

    // если кнопка не заблочена - показываем модалку
    if (!$button.prop(self.selectors.disabled.value)) {
      // Если задан fake_order, то добавляем скрытые поля в форму
      if ($button.data(self.selectors.open.data) === 'fake_order') {
        self.setFakeOrderFields($button, modalHandle);
      } else {
        modal._targetForm = self._getProductForm($button);
      }

      modal._targetButton = $button;
      self.openModal($modalNode);
      modal.$form.find('input:visible:first').focus();
    } else {
      // иначе - дергаем событие
      EventBus.publish('add_disabled:insales:quick_checkout', { button: $button });
    }

    self._renderCaptchaOnVisible($modalNode.get(0), modal);

    if (!self.phoneMaskInited) {
      initPhoneFieldMask();
      self.phoneMaskInited = true;
    }
  });
};

/**
 * Рендеринг капчи при появлении блока в зоне видимости
 * @method
 * @private
 * @param {HTMLElement} modalNode - нода модального окна
 * @param {Object} modal - объект модального окна
 * @returns {void}
 */
QuickCheckoutUI.prototype._renderCaptchaOnVisible = function(modalNode, modal) {
  const self = this;

  const quickCheckoutYandexCaptchaBlock = modalNode.querySelector(self.selectors.yandexCaptcha.value);
  if (self.captchaType === CAPTCHA_TYPE_YANDEX && quickCheckoutYandexCaptchaBlock) {
    renderYandexCaptchaWidgetOnVisible({
      context: self,
      captchaBlock: modal.captchaBlockInner
    });

    return;
  }

  const quickCheckoutRecaptchaBlock = modalNode.querySelector(self.selectors.recaptcha.value);
  if (self.captchaType === CAPTCHA_TYPE_GOOGLE && quickCheckoutRecaptchaBlock) {
    renderRecaptchaWidgetOnVisible(self, quickCheckoutRecaptchaBlock);
  }
};

/**
 * Сбор формы из модалки
 * @method
 * @private
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @fires before:insales:quick_checkout
 * @fires always:insales:quick_checkout
 *
 * @returns {Object} formData - объект с формой для ajax отправки и task
 */
QuickCheckoutUI.prototype.getFormData = function(modalHandle) {
  const self = this;
  const modal = self[modalHandle];
  const ajaxParams = {};
  const formData = {};

  const task = {
    action: {
      method: 'send',
      modal: modal.$modal,
      form: modal.$form
    }
  };

  // eslint-disable-next-line id-blacklist
  ajaxParams.data = new FormData(modal.$form.get(0));
  ajaxParams.processData = false;
  ajaxParams.contentType = false;

  formData.ajaxParams = ajaxParams;
  formData.task = task;

  modal.$errors.html('');

  return formData;
};

/**
 * Обработчики закрытия модалки
 * @method
 * @private
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype._bindCloseModal = function(modalHandle) {
  const self = this;

  self[modalHandle].$close.off('click').on('click', function(event) {
    self._close(event, modalHandle);
  });

  jquery(document)
    .on('click', '.m-overlay', function(event) {
      self._close(event, modalHandle);
    })
    .on('keyup', function(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        self._close(event, modalHandle);
      }
    });
};

/**
 * Обнуляем переменные перед закрытием
 * @method
 * @private
 *
 * @param {Event} event - текущая нода
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype._close = function(event, modalHandle) {
  const self = this;
  const modal = self[modalHandle];

  event.preventDefault();
  self._clearStore();
  modal._targetForm = {};
  modal._targetButton = {};
  self.closeModal(jquery('.m-modal'), modalHandle);
  modal.$errors.html('');

  // Удаляем поля fake_order
  if (modal.fake_order_field) {
    modal.fake_order_field.remove();
    modal.fake_order_field = null;
  }

  if (modal.fake_order_name_field) {
    modal.fake_order_name_field.remove();
  }
};

QuickCheckoutUI.prototype._clearStore = function() {
  Store.getItem('quick-checkout').then(function(items) {
    if (items) {
      window.InsalesCommonCart.remove({ items });
    }
    Store.setItem('quick-checkout', null);
  });
};

/**
 * Перехватываем события DOM для отправки формы
 * @method
 * @private
 * @param {string} modalHandle - handle модального окна (service/default)
 * @returns {void}
 */
QuickCheckoutUI.prototype._bindSend = function(modalHandle) {
  const self = this;
  const modal = self[modalHandle];

  // сносим все обработчики и вешаем свои
  modal.$send.off('click').on('click', function(event) {
    event.preventDefault();
    if (modal.sending) { return; }
    modal.sending = true;
    self.sendResponse(modalHandle);
  });

  modal.$form.on('keypress', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (modal.sending) { return; }
      modal.sending = true;
      self.sendResponse(modalHandle);
    }
  });
};

/**
 * Запуск добавления товаров, отправка формы
 * @method
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype.sendResponse = function(modalHandle) {
  const self = this;
  const modal = self[modalHandle];

  if (
    modal.captchaEnabled && (Shop.config.config.theme_generation > 3 || self.captchaType === CAPTCHA_TYPE_YANDEX)
  ) {
    const captchaCallback = function() {
      return self.sendResponse(modalHandle);
    };

    // Получаем данные и статус капчи
    const captchaResult = getCaptchaMessageData({
      captchaType: self.captchaType,
      form: modal.$form.get(0),
      fieldRecaptcha: modal.$form.find(self.selectors.recaptcha.value).get(0),
      fieldYandexCaptcha: modal.$form.find(self.selectors.yandexCaptcha.value).get(0),
      callback: captchaCallback
    });

    if (captchaResult.status === 'pending') {
      modal.sending = false;

      return;
    }
  }

  const formData = self.getFormData(modalHandle);

  // Если задан fake_order, то отправляем форму без запроса к корзине и без товара. При этом, не сбрасываем корзину после отправки (withoutCart: true).
  if (modal.fake_order_field) {
    const params = {
      formData,
      fakeOrder: true
    };
    if (modal.fake_order_name_field) {
      params.fakeOrderName = modal.fake_order_name_field.value;
    }
    self.sendFormWithoutCart(params);

    return;
  }

  self.targetFormState(true, modalHandle);
  const currentProduct = CartDOM._parseProductForm(
    modal._targetForm,
    modal._targetButton
  );

  // Если передан флаг useCommonCart, то отправляем форму и отдельным запросом к корзине все товары которые лежат в корзине
  if (modal.useCommonCart) {
    currentProduct.formData = formData;

    Store.getItem('quick-checkout').then(function(itemsStorage) {
      const tempItems = currentProduct.items;
      Store.setItem('quick-checkout', tempItems);
      if (_isEqual(currentProduct.items, itemsStorage)) {
        currentProduct.items = {};
      }
      window.InsalesCommonCart.add_checkout(currentProduct);
    });

    return;
  }

  // Добавляем в форму текущий товар и отправляем её без отдельного запроса к корзине
  self.addCurrentProductToForm(currentProduct.items, formData);
  self.sendFormWithoutCart({
    formData,
    oneClickBasketPath: true
  });
};

/**
 * Добавляем текущий товар в форму
 * @method
 * @private
 * @param {Object} items - объект с товарами
 * @param {Object} formData - объект с формой для ajax отправки
 * @returns {void}
 */
QuickCheckoutUI.prototype.addCurrentProductToForm = function(items, formData) {
  for (const [ itemKey, itemValue ] of Object.entries(items)) {
    if (itemKey !== 'accessoriable_variant_ids') {
      // Товары без опций
      formData.ajaxParams.data.append(
        `variants[variant_ids][${itemKey}]`,
        itemValue
      );
      break;
    }

    for (const [ variantId, itemsArray ] of Object.entries(itemValue)) {
      itemsArray.forEach((accessoriableItem, index) => {
        formData.ajaxParams.data.append(
          `variants[accessoriable_variant_ids][${variantId}][${index}][quantity]`,
          accessoriableItem.quantity
        );

        for (const [ accessoryId, quantity ] of Object.entries(
          accessoriableItem.accessory_value_ids
        )) {
          formData.ajaxParams.data.append(
            `variants[accessoriable_variant_ids][${variantId}][${index}][accessory_value_ids][${accessoryId}]`,
            quantity
          );
        }
      });
    }
  }
};

/**
 * Отправка формы без запроса к корзине
 * @method
 * @private
 * @param {Object} params - параметры отправки
 * @param {Object} params.formData - объект с формой для ajax отправки
 * @param {boolean} params.oneClickBasketPath
 * @param {boolean} params.fakeOrder
 * @param {string} params.fakeOrderName
 * @fires add_checkout:insales:cart
 * @returns {void}
 */
QuickCheckoutUI.prototype.sendFormWithoutCart = function({
  formData,
  oneClickBasketPath,
  fakeOrder,
  fakeOrderName
}) {
  const quickCheckoutData = { action: {} };

  quickCheckoutData.action.formData = formData;

  const ajaxParams = quickCheckoutData.action.formData.ajaxParams;
  ajaxParams.withoutCart = true;
  ajaxParams.oneClickBasketPath = oneClickBasketPath;
  ajaxParams.fakeOrder = fakeOrder;
  ajaxParams.fakeOrderName = fakeOrderName;

  EventBus.publish('add_checkout:insales:cart', quickCheckoutData);
};

/**
 * Разбор формы модалки
 * @method
 * @private
 *
 * @param {Object} $button - jQuery-объект ноды
 * @returns {Object} $form - jQuery-нода формы
 */
QuickCheckoutUI.prototype._getProductForm = function($button) {
  const self = this;
  const target = $button.attr(self.selectors.open.value) || false;
  const parentForm = $button.parents('form:first') || false;
  let $form = null;

  if (target && jquery(target).is('form')) {
    $form = jquery(target);
  } else if (parentForm && jquery(parentForm).is('form')) {
    $form = jquery(parentForm);
  } else {
    console.warn('QuickCheckoutUI: _getProductForm: target form: WAAAAT?!');
  }

  return $form;
};

/**
 * Показываем сообщения из чекаута
 * @method
 * @private
 *
 * @param {Object} task - Задача
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {void}
 */
QuickCheckoutUI.prototype.showMessage = function(task, modalHandle) {
  const self = this;
  self.closeModal(self[modalHandle].$modal, modalHandle);
  self.openModal(self.$message);

  // Сбрасываем капчу после успешной отправки
  resetCaptcha({
    captchaType: self.captchaType,
    yandexCaptchaBlockSelector: self.selectors.yandexCaptcha.value,
    googleRecaptchaBlockSelector: self.selectors.recaptcha.value,
  });

  jquery('.m-modal-msg', self.$message).html(task.message);

  if (window.innerWidth < 600) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }
};

/**
 * Прячем сообщения
 * @method
 * @private
 * @returns {void}
 */
QuickCheckoutUI.prototype.hideMessage = function() {
  const self = this;
  self.closeModal(self.$message);
};

/**
 * Проверяем что форма привязана
 * @method
 * @private
 *
 * @param {boolean} state - состояние
 * @param {string} modalHandle - handle модального окна (service/default)
 * @returns {void}
 */
QuickCheckoutUI.prototype.targetFormState = function(state, modalHandle) {
  const self = this;
  const modal = self[modalHandle];

  if (!modal._targetForm) {
    console.warn(
      'Форма вызвана не системным методом! Используйте атрибут data-quick-checkout для кнопки вызова формы'
    );

    return;
  }
  modal._targetForm._quickCheckout = state;
};

/**
 * @private
 *
 * @description
 * Получение текста из словаря базовых сообщений
 *
 * @param {string} messageName - название сообщения
 * @returns {string} текст сообщения
 */
QuickCheckoutUI.prototype._getMessageByLocale = function(messageName) {
  const self = this;
  if (typeof self.locale !== 'undefined') {
    let resultMessage = self.defaultSettings[messageName][self.locale];
    if (typeof resultMessage === 'undefined') {
      resultMessage = self.defaultSettings[messageName].ru;
    }

    return resultMessage;
  }

  return self.defaultSettings[messageName].ru;
};

/**
 * @private
 *
 * @description
 * Создание скрытых полей для передачи fake_order
 *
 * @param {Object} $button - кнопка которая вызвала форму
 * @param {string} modalHandle - handle модального окна (service/default)
 * @returns {void}
 */
QuickCheckoutUI.prototype.setFakeOrderFields = function($button, modalHandle) {
  const self = this;
  const modal = self[modalHandle];

  modal.fake_order_field = self.createInput('fake_order', 'true', modalHandle);

  const fakeOrderName = $button.data(self.selectors.fakeOrderName.data);
  if (!fakeOrderName) { return; }

  modal.fake_order_name_field =
    self.createInput('fake_order_name', fakeOrderName, modalHandle);
};

/**
 * @private
 *
 * @description
 * Вспомогательный метод для создания поля для передачи данных и добавления его в форму
 *
 * @param {string} name - значение атрибута name
 * @param {string} value - значение атрибута value
 * @param {string} modalHandle - handle модального окна (service/default)
 *
 * @returns {HTMLElement} - input
 */
QuickCheckoutUI.prototype.createInput = function(name, value, modalHandle) {
  const self = this;
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;

  self[modalHandle].$form.append(input);

  return input;
};

export default _Singleton(QuickCheckoutUI).getInstance();
